import React, { useRef, forwardRef } from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'

import classes from './InputSearch.module.scss'

/** @type {import("./types").default} */
const InputSearch = forwardRef(
  (
    {
      value = '',
      onFocus,
      onChange,
      onMouseDown,
      onClear = () => {},
      onBlur = () => {},
      testId = 'InputSearch' /* ToDo: remove & use directly data-testid */,
      placeholder = 'Type an app name',
      className,
      colorVariant,
      size,
      placeholderCentered,
      ...props
    },
    forwardedRef
  ) => {
    const innerRef = useRef()
    const finalRef = forwardedRef || innerRef

    return (
      <div
        className={clsx(
          'InputSearch',
          classes.root,
          classes[colorVariant],
          classes[size],
          { [classes.placeholderCentered]: placeholderCentered },
          className
        )}
      >
        <input
          type="text"
          value={value}
          placeholder={placeholder}
          className={classes.input}
          onFocus={onFocus}
          onBlur={e => {
            onBlur(e)
            if (finalRef.current) {
              finalRef.current.blur()
            }
          }}
          onChange={onChange}
          onMouseDown={onMouseDown}
          data-testid={testId}
          ref={finalRef}
          {...props}
        />
        {!!value ? (
          <Icon
            data-testid="btn-clear"
            icon={['fas', 'times-circle']}
            size="20"
            role="button"
            className={clsx(classes.icon, classes.clickable)}
            onClick={() => {
              onClear()
              if (finalRef.current) {
                finalRef.current.focus()
              }
            }}
          />
        ) : (
          <Icon data-testid="icon-search" icon={['fas', 'search']} size="20" className={classes.icon} />
        )}
      </div>
    )
  }
)

export default InputSearch
